import { set } from 'lodash';
import { MaterialDesignSvg } from '../MaterialDesign/MaterialDesignSvg';

export class ThumbsUpDownRater extends HTMLElement {


    rating_prompt = 'Do you agree with this report?';
    helpful_prompt = 'Please tell us why you felt that this report was helpful?';

    marketing_label = 'We greatly appreciate your comments.<br/>  Please let us know if we can use your feedback in any of our marketing   content.';

    message_label = 'Please type your feedback here';
    message_label_disagree = '10 or more characters, please <span class="mandatory-star">*</span>';

    disagree_prompt = '<span class="mandatory-star">*</span> Please tell us why you disagree with this report. Your feedback will be shared with our team and radiologists for review.';

    constructor() {
        super();
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.createComponents();
        this.loadEventHandlers();
    }

    createComponents() {
        if (this.dataset.prompt !== 'false') {
            const textDiv = document.createElement('div');
            textDiv.classList.add('rating-prompt');
            textDiv.innerHTML = this.rating_prompt;
            this.appendChild(textDiv);
        }
        this.createThumbs();
    }

    createThumbs() {
        const thumbsDiv = document.createElement('div');
        thumbsDiv.classList.add('thumbs-container');
        this.appendChild(thumbsDiv);

        // thumbs up button
        const thumbsUpBtn = document.createElement('a');
        thumbsUpBtn.classList.add('thumb-btn', 'thumb-up');
        thumbsUpBtn.setAttribute('tabindex', '-1');
        const thumbsUpSvg = this.createThumbSvg('thumb_up');
        thumbsUpBtn.appendChild(thumbsUpSvg);
        thumbsDiv.appendChild(thumbsUpBtn);

        // thumbs down button
        const thumbsDownBtn = document.createElement('a');
        thumbsDownBtn.classList.add('thumb-btn', 'thumb-down');
        thumbsDownBtn.setAttribute('tabindex', '-1');
        const thumbsDownSvg = this.createThumbSvg('thumb_down');
        thumbsDownBtn.appendChild(thumbsDownSvg);
        thumbsDiv.appendChild(thumbsDownBtn);
    }


    createThumbSvg(type) {
        const svg = document.createElement('material-design-svg');
        svg.classList.add('thumb-svg', 'thumb-up');
        svg.setAttribute('data-icon', `filled__${type}`);
        svg.classList.add(type);
        svg.dataset.iconSize = '24';
        return svg;
    }

    loadEventHandlers() {
        const ratingBtns = this.querySelectorAll('.thumb-btn');
        ratingBtns.forEach(btn => {
            const row = btn.closest('tr');
            if (!row || !row.classList.contains('deleted')) { 
                btn.addEventListener('click', this.onThumbClick.bind(this));
            }
        });

    }

    onThumbClick(event) {
        const btnType = event.currentTarget.classList.contains('thumb-up') ? 'up' : 'down';
        const ratingDlg = this.createRatingDialog(btnType);
        this.appendChild(ratingDlg);
        ratingDlg.showModal();
        ratingDlg.style.height = '650px';
        ratingDlg.style.opacity = '1';
        ratingDlg.style.width = '750px';

        setTimeout(() => {
            document.addEventListener('click', (event) => {
                if (!event.target.contains(ratingDlg)) {
                    return;
                }

                this.closeDialog(ratingDlg);
            });
        }, 100);

    }

    closeDialog(ratingDlg) {
        ratingDlg.addEventListener('transitionend', () => {
            ratingDlg.close();
            ratingDlg.remove();
        });

        ratingDlg.style.height = '0';
        ratingDlg.style.opacity = '0';
        ratingDlg.style.width = '0';
    }

    createRatingDialog(rating) {
        const reportType = this.dataset.report_type;
        const ratingDlg = document.createElement('dialog');
        ratingDlg.classList.add('rating-dialog', 'thumbs-' + rating);
        const dlgBody = document.createElement('div');
        dlgBody.classList.add('dialog-body');
        ratingDlg.appendChild(dlgBody);
        if (rating === 'up') {
            const helpfulPrompt = document.createElement('div');
            helpfulPrompt.classList.add('helpful-prompt');
            helpfulPrompt.innerHTML = this.helpful_prompt;
            dlgBody.appendChild(helpfulPrompt);
        }

        const reportedByDiv = this.createReportedByDiv();
        dlgBody.appendChild(reportedByDiv);

        if (reportType == 'ai' && this.dataset.body_regions) {
            const bodyRegions = JSON.parse(this.dataset.body_regions);
            const ReportDropdown = this.createAiReportTypeDropdown(bodyRegions);
            dlgBody.appendChild(ReportDropdown);
        } else {
            const ReportHeader = this.createReportHeader();
            dlgBody.appendChild(ReportHeader);
        }

        const marketingAcceptanceDiv = this.createMarketingAcceptanceDiv();
        dlgBody.appendChild(marketingAcceptanceDiv);

        if (rating === 'down') {
            const disagreePrompt = document.createElement('div');
            disagreePrompt.classList.add('disagree-prompt');
            disagreePrompt.innerHTML = this.disagree_prompt;
            dlgBody.appendChild(disagreePrompt);
         }

        const messageDiv = this.createMessageDiv(rating);
        dlgBody.appendChild(messageDiv);

        const sendBtn = this.createSendButton();
        dlgBody.appendChild(sendBtn);


        return ratingDlg;
    }

    createSendButton() {
        const sendBtnContainer = document.createElement('div');
        sendBtnContainer.classList.add('send-btn-container');

        const sendBtn = document.createElement('button');
        sendBtn.classList.add('send-btn');
        sendBtn.innerHTML = 'Send';
        sendBtnContainer.appendChild(sendBtn);
        sendBtn.addEventListener('click', this.onSendClick.bind(this));
        return sendBtnContainer;
    }

    onSendClick(event) {
        const ratingDlg = event.currentTarget.closest('.rating-dialog');
        const reportedBy = ratingDlg.querySelector('.reported-by').value;
        const marketingAcceptance = ratingDlg.querySelector('input[name="marketing-acceptance"]');
        const marketingAgree = marketingAcceptance.checked ? 'yes' : 'no';
        const description = ratingDlg.querySelector('.message-text').value;
        const rating = ratingDlg.classList.contains('thumbs-up');

        if (rating == false && description.trim().length < 10) {
            toastr.error('Please enter at least 10 characters for your feedback', 'Missing Info', {
                positionClass: 'toast-bottom-center',
            });
            const descrElem = this.querySelector('textarea.message-text');
            descrElem.focus();
            return;
        }

        if (reportedBy.trim() === "") {
            toastr.error('Reported By is required', 'Missing Info', {
                positionClass: 'toast-bottom-center',
            });
            const reportedByElem = this.querySelector('input.reported-by');
            reportedByElem.focus();
            return;
        }

        if (this.dataset.report_type == 'ai' && this.dataset.body_regions) {
            const reportTypeSelect = ratingDlg.querySelector('#report-type');
            if (reportTypeSelect.value === '') {
                toastr.error('Please select a report region', 'Missing Info', {
                    positionClass: 'toast-bottom-center',
                });
                reportTypeSelect.focus();
                return;
            }
        }

        this.sendResults(reportedBy, marketingAgree, description, rating);
    }

    sendResults(reportedBy, market_agree, description, rating) {
        // get the report type 
        const reportType = this.dataset.report_type;
        // get selected region if ai report
        // send results to server
        const formData = new FormData();
        formData.append('reported_by', reportedBy);
        formData.append('marketing_agree', market_agree);
        formData.append('description', description);
        formData.append('like', rating);
        if (reportType == 'rad') {
            formData.append('report_id', this.dataset.report_id);
        } else {
            formData.append('case_id', this.dataset.case_id);
            if (this.dataset.body_regions) {
                formData.append('ai_screening_eval_type_id', this.querySelector('#report-type').value);
            } else {
                formData.append('ai_screening_eval_type_id', this.dataset.ai_screening_eval_type_id);
            }
        }
        fetch('/api/' + reportType + '-report-feedback', {
            method: 'POST',
            Accept: 'application/json',
            body: formData
        }).then(response => {
            if (response.ok) {
                toastr.success('Thank you for your feedback', 'Feedback Sent');
                const ratingDlg = this.querySelector('.rating-dialog');
                this.closeDialog(ratingDlg);
            } else {
                // get error messages
                response.json().then(data => {
                    let errors = '';
                    for (const key in data.errors) {
                        errors += data.errors[key] + '\n';
                    }
                    toastr.error(errors, 'Error sending feedback');
                });
            }
        });
    }

    createMessageDiv(rating) {

        const messageFieldset = document.createElement('fieldset');
        messageFieldset.classList.add('message-fieldset', 'floating-label', 'thumbs-' + rating);

        // add input
        const messageInput = document.createElement('textarea');
        if (rating == "down") {
            messageInput.setAttribute('required', 'required');
            messageInput.setAttribute('minlength', 10);
        }
        if (this.dataset.report_type === 'rad') {
            messageInput.setAttribute('maxlength', 255);
        }
        messageInput.classList.add('message-text');
        messageFieldset.appendChild(messageInput);

        // add label
        const messageLabel = document.createElement('label');
        messageLabel.classList.add('message-label');
        if (rating == "down") {
            messageLabel.innerHTML = this.message_label_disagree;
        } else {
            messageLabel.innerHTML = this.message_label;
        }
        messageLabel.setAttribute('for', 'message');
        messageFieldset.appendChild(messageLabel);
        return messageFieldset;
    }

    createMarketingAcceptanceDiv() {
        const marketingAcceptance = document.createElement('div');
        marketingAcceptance.classList.add('marketing-acceptance');
        const marketingLabel = document.createElement('label');
        marketingLabel.innerHTML = this.marketing_label;
        marketingLabel.classList.add('marketing-label');
        marketingAcceptance.appendChild(marketingLabel);
        const acceptanceToggle = document.createElement('on-off-switch');
        acceptanceToggle.classList.add('acceptance-switch');
        acceptanceToggle.dataset.off_text = 'No';
        acceptanceToggle.dataset.on_text = 'Yes';
        acceptanceToggle.dataset.off_background_color = '#7a7c81';
        acceptanceToggle.dataset.off_text_color =  '#fff';
        acceptanceToggle.dataset.on_background_color = '#357ca5';
        acceptanceToggle.dataset.on_text_color = '#fff';
        acceptanceToggle.dataset.pill_color = '#f3b861';
        acceptanceToggle.dataset.initial_state = 'off';
        acceptanceToggle.dataset.name = 'marketing-acceptance';
        marketingAcceptance.appendChild(acceptanceToggle);
        return marketingAcceptance;
    }

    createReportedByDiv() {
        const reportedByDiv = document.createElement('div');
        reportedByDiv.classList.add('form-floating');
        const reportedByInput = document.createElement('input');
        reportedByInput.setAttribute('type', 'text');
        reportedByInput.setAttribute('required', 'required');
        reportedByInput.setAttribute('minlength', 3);
        if (this.dataset.report_type === 'rad') {
            reportedByInput.setAttribute('maxlength', 100);
        }
        reportedByInput.setAttribute('placeholder', '');
        reportedByInput.setAttribute('tabindex', '0');
        reportedByInput.classList.add('reported-by');
        reportedByInput.id = 'reported-by';
        reportedByDiv.appendChild(reportedByInput);
        const reportedByLabel = document.createElement('label');
        reportedByLabel.classList.add('required-label');
        reportedByLabel.innerHTML = 'Reported By *';
        reportedByLabel.setAttribute('for', 'reported-by');
        reportedByDiv.appendChild(reportedByLabel);
        return reportedByDiv;
    }

    createReportHeader() {
        const ReportHeader = document.createElement('div');
        ReportHeader.classList.add('report-header');
        const ReportTitle = document.createElement('h3');
        ReportTitle.innerHTML = this.dataset.report_title; 
        ReportHeader.appendChild(ReportTitle);
        return ReportHeader;
    }

    createAiReportTypeDropdown(bodyRegions)
    {
        const dropdownDiv = document.createElement('div');
        dropdownDiv.classList.add('ai-report-type-dropdown', 'floating-label');
        const label = document.createElement('label');
        label.setAttribute('for', 'report-type');
        label.innerHTML = 'Report Region *';
        const select = document.createElement('select');
        select.setAttribute('id', 'report-type');
        select.setAttribute('name', 'report-type');
        const option = document.createElement('option');
        option.setAttribute('value', '');
        option.setAttribute('disabled', 'disabled');
        option.setAttribute('selected', 'selected');
        option.innerHTML = 'Select a region...';
        select.appendChild(option);
        Object.entries(bodyRegions).forEach(([body_region, screening_eval_type_id]) => {
            const option = document.createElement('option');
            option.setAttribute('value', screening_eval_type_id);
            option.innerHTML = `Virtual Radiology ${this.dataset.species_name} ${body_region} Screening`;
            select.appendChild(option);
        });
        dropdownDiv.appendChild(select);
        dropdownDiv.appendChild(label);
        return dropdownDiv;
    }

}

customElements.define('thumbs-up-down-rater', ThumbsUpDownRater);